import React, { useEffect } from "react";
import Lottie from "lottie-react";
import countdownAnimationData from "../assets/Final-321-go.json";
import { useSoundContext } from "../contexts/SoundContext";

const CountdownAnimation = () => {
  const { playSoundEffect } = useSoundContext();

  useEffect(() => {
    // Play countdown sound when animation starts
    playSoundEffect("countdown");
  }, [playSoundEffect]);

  return (
    <Lottie
      animationData={countdownAnimationData}
      loop={false}
      autoplay={true}
      style={{ width: "180px", height: "180px" }}
    />
  );
};

export default CountdownAnimation;
